import { ModalDialogContext } from "./modal-dialog.context";

import type { ModalDialogProviderProps } from "../modal-dialog.types";

export function ModalDialogProvider({
  children,
  onClose = () => null,
}: ModalDialogProviderProps) {
  return (
    <ModalDialogContext.Provider value={{ onClose }}>
      {children}
    </ModalDialogContext.Provider>
  );
}
